var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRfid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_841_17478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
    fill: "#4E5968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1001 10.1801C7.3601 10.7401 7.4901 11.3401 7.5001 11.9801C7.5101 12.6101 7.3701 13.2301 7.1001 13.8401L8.4701 14.4601C8.8401 13.6501 9.0201 12.8101 9.0101 11.9601C9.0001 11.1201 8.8201 10.3101 8.4701 9.56006L7.1001 10.1801Z",
    fill: "#4E5968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3301 7.32991C14.1101 8.89991 14.5101 10.4699 14.5101 11.9699C14.5101 13.4799 14.1101 15.0599 13.3301 16.6599L14.6801 17.3199C15.5601 15.5099 16.0101 13.7099 16.0101 11.9699C16.0101 10.2299 15.5601 8.43991 14.6801 6.65991L13.3301 7.32991Z",
    fill: "#4E5968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2 8.72005C10.73 9.79005 11 10.93 11 12.12C11 13.29 10.74 14.35 10.22 15.27L11.52 16.01C12.17 14.86 12.5 13.56 12.5 12.12C12.5 10.7 12.18 9.33005 11.54 8.05005L10.2 8.72005Z",
    fill: "#4E5968"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_841_17478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfid);
export default __webpack_public_path__ + "static/media/RFID.c898f56519ac024f74b09a77d4aab4ed.svg";
export { ForwardRef as ReactComponent };